import React from "react";
import Projects from '../Projects';

function Portfolio() {
    return (
        <section>
            <h1 className="section-title portfolio-title">My Portfolio</h1>
            <Projects />
        </section>
    );
}

export default Portfolio;